import React from 'react';
import './DislikeButton.css';

export class DislikeButton extends React.Component {

  static getButtonId (id) {
    return `dislike-button-${id}`;
  }

  static getIconId (id) {
    return `dislike-icon-${id}`;
  }

  render () {
    const { id, className } = this.props;
    return (
      <div className={ `presentation-animations ${!!className ? className : ''}` }>
        <button id={ DislikeButton.getButtonId(id) } className="thumb_down">
          <svg
            id={ DislikeButton.getIconId(id) }
            width="22px"
            height="20px"
            viewBox="0 0 22 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg">
            <g id="Live-View" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Artboard-2" transform="translate(-154.000000, -60.000000)">
                <g id="Group-2" transform="translate(138.000000, 46.000000)">
                  <path d="M16,33.1434297 L16,21.6573719 L19.8325618,21.6573719 L19.8325618,33.1434297 L16,33.1434297 Z M37.0790899,22.6145434 L37.0695085,22.6911171 L37.0790899,22.7006888 L37.0790899,24.5288863 C37.0790899,24.7777509 37.0311829,25.0074721 36.9449503,25.2276215 L34.0513661,31.9756805 C33.763924,32.6648439 33.0836442,33.1434297 32.2883877,33.1434297 L23.6651236,33.1434297 C22.6111691,33.1434297 21.7488427,32.2819753 21.7488427,31.2290867 L21.7488427,21.6573719 C21.7488427,21.1309276 21.9596336,20.6523418 22.3141456,20.3077601 L28.6187097,14 L29.6343386,15.0050301 C29.8930365,15.2634664 30.0559204,15.6271915 30.0559204,16.0196318 L30.0271762,16.3259267 L29.1169428,20.7002004 L35.162809,20.7002004 C36.2167635,20.7002004 37.0790899,21.5616547 37.0790899,22.6145434 Z" id="ic_thumb_up_Inactive" fill="#FF595C" transform="translate(26.539545, 23.571715) scale(-1, -1) translate(-26.539545, -23.571715) "></path>
                  <rect id="Rectangle-31" x="0" y="0" width="50" height="50"></rect>
                </g>
              </g>
            </g>
          </svg>
        </button>
      </div>
    );
  }
}
